{
  "shared": {
    "form": {
      "notSaved": "Not saved",
      "saved": "Changes saved.",
      "discard": {
        "title": "Discard unsaved changes?",
        "body": "What you typed in this form has not been saved. If you leave now, it is lost.",
        "keep": "Keep editing",
        "discard": "Discard changes"
      },
      "money": {
        "required": "Enter an amount.",
        "format": "Enter the amount in figures, like 1250.50: digits and one decimal point, no commas.",
        "negative": "The amount cannot be negative.",
        "decimals": "Use at most {{places}} digits after the decimal point."
      },
      "supplier": {
        "newTitle": "Add supplier",
        "newSubtitle": "A new supplier starts as a draft. It can be ordered from only after it is activated and its qualification is approved.",
        "editTitle": "Edit {{name}}",
        "editSubtitle": "Purchase orders already issued keep the supplier details they were issued with.",
        "submitNew": "Add supplier",
        "submitEdit": "Save changes",
        "summaryNew": "The supplier was not added",
        "summaryEdit": "The changes were not saved",
        "added": "Supplier {{code}} added as a draft.",
        "addedNext": "Next: activate it, then complete its qualification, before anyone orders from it.",
        "saved": "Supplier {{code}} saved.",
        "openRecord": "Open supplier record",
        "addAnother": "Add another supplier",
        "backToList": "Back to suppliers",
        "notAvailableTitle": "Not available to you",
        "notAvailableBody": "Adding and editing suppliers is not part of your role. Ask an administrator if you need it.",
        "sections": {
          "identity": "Identity",
          "identityHint": "How this supplier is named in your organisation and on its registration.",
          "legal": "Legal & tax",
          "legalHint": "Checked against the format the authorities issue. Each number is unique among your suppliers.",
          "contact": "Primary contact",
          "contactHint": "The supplier's general contact details.",
          "commercial": "Commercial terms",
          "commercialHint": "For reference. Every agreement and order states its own currency and terms."
        },
        "code": {
          "placeholder": "RET-SUP-001",
          "hint": "Internal code used to identify this supplier. Letters, digits, - and _ only; unique in your organisation."
        },
        "nameEn": {
          "label": "Name (English)",
          "placeholder": "Example Catering Supplies"
        },
        "nameAr": {
          "label": "Name (Arabic)",
          "placeholder": "مؤسسة مثال للتموين"
        },
        "nameHint": "The name people in your organisation know this supplier by.",
        "legalNameEn": {
          "label": "Legal name (English)",
          "placeholder": "Example Catering Supplies Co. Ltd."
        },
        "legalNameAr": {
          "label": "Legal name (Arabic)",
          "placeholder": "شركة مثال للتموين المحدودة"
        },
        "legalNameHint": "As written on the commercial registration. Leave it empty when it is the same as the name.",
        "cr": {
          "placeholder": "1010123456",
          "hint": "10 digits."
        },
        "vat": {
          "placeholder": "310123456700003",
          "hint": "15 digits, beginning and ending with 3."
        },
        "email": {
          "label": "Email",
          "placeholder": "purchasing@supplier.example",
          "hint": "The supplier's general purchasing address."
        },
        "phone": {
          "label": "Phone",
          "placeholder": "+966 5X XXX XXXX",
          "hint": "Include the country code."
        },
        "website": {
          "placeholder": "https://www.supplier.example",
          "hint": "The full address, starting with https://."
        },
        "currency": {
          "hint": "For reference only. No amount is ever converted with it.",
          "none": "Not set",
          "inactive": "{{code}} (no longer enabled)"
        },
        "paymentTerms": {
          "placeholder": "30 days from invoice",
          "hint": "As agreed with the supplier, in a few words."
        },
        "leadTime": {
          "label": "Usual lead time",
          "unit": "days",
          "placeholder": "7",
          "hint": "Days from order to delivery, from 0 to 365."
        },
        "problems": {
          "codeRequired": "Enter the supplier code.",
          "codeFormat": "Use letters, digits, - or _ only, up to 40 characters.",
          "nameEnRequired": "Enter the name in English.",
          "nameArRequired": "Enter the name in Arabic.",
          "crFormat": "A commercial registration is exactly 10 digits.",
          "vatFormat": "A VAT number is 15 digits, beginning and ending with 3.",
          "emailFormat": "Enter an email address like purchasing@supplier.example.",
          "websiteFormat": "Enter the full address, starting with https://.",
          "leadTimeFormat": "Enter whole days, from 0 to 365."
        },
        "archivedTitle": "This supplier is archived",
        "archivedBody": "An archived supplier's record is kept as it was and cannot be edited."
      },
      "requiredNote": "Fields marked * are required.",
      "user": {
        "editTitle": "Edit {{name}}",
        "summary": "The user was not saved",
        "added": "{{name}} added.",
        "saved": "{{name}} saved.",
        "sections": {
          "person": "Person",
          "personHint": "Who this account is for. They sign in with the email address.",
          "access": "Access",
          "accessHint": "What they may do. Each role is a set of permissions your organisation defines.",
          "scope": "Where they work",
          "scopeHint": "Whose records they see and act on."
        },
        "name": {
          "placeholder": "Sara Example"
        },
        "nameAr": {
          "placeholder": "سارة المثال"
        },
        "email": {
          "placeholder": "name@organisation.example",
          "hint": "Their sign-in address. It must be unique in your organisation."
        },
        "jobTitle": {
          "placeholder": "Procurement officer"
        },
        "scope": {
          "hint": "The whole organisation, chosen purchasing units, or none yet.",
          "none": "None yet"
        },
        "nodes": {
          "label": "Purchasing units",
          "hint": "Search by name or code. They see and act on these purchasing units' records only.",
          "placeholder": "Add a purchasing unit"
        },
        "problems": {
          "nameRequired": "Enter their name.",
          "emailRequired": "Enter their email address.",
          "emailFormat": "Enter an email address like name@organisation.example."
        }
      },
      "role": {
        "summary": "The permissions were not saved",
        "saved": "Permissions of {{name}} saved.",
        "find": "Find a permission",
        "findPlaceholder": "Search permissions",
        "selected": "{{selected}} of {{total}} chosen",
        "noMatch": "No permission matches “{{term}}”."
      },
      "editTitle": "Edit {{name}}",
      "addedNamed": "{{name}} added.",
      "savedNamed": "{{name}} saved.",
      "problems": {
        "codeFormat": "Use letters, digits, - or _ only, up to 40 characters."
      },
      "node": {
        "summary": "The purchasing unit was not saved",
        "sections": {
          "identity": "Identity",
          "identityHint": "How this purchasing unit is named and coded across your organisation."
        },
        "code": {
          "placeholder": "RUH-MAIN"
        },
        "costCenter": {
          "placeholder": "CC-1001",
          "hint": "Your finance system's cost centre, for reference."
        }
      },
      "agreement": {
        "summaryCreate": "The agreement was not added",
        "summaryEdit": "The changes were not saved",
        "summaryItem": "The line was not added",
        "summaryReprice": "The price was not changed",
        "added": "Agreement {{reference}} added as a draft.",
        "saved": "Agreement {{reference}} saved.",
        "itemAdded": "{{name}} added to the agreement.",
        "repriced": "The new price of {{name}} is recorded.",
        "sections": {
          "agreement": "Agreement",
          "agreementHint": "How it is referenced and named.",
          "validity": "Validity",
          "validityHint": "Its prices apply from the first day to the last, both included.",
          "terms": "Commercial terms",
          "item": "The line",
          "itemHint": "What the supplier supplies under this agreement.",
          "price": "Price and order"
        },
        "reference": {
          "placeholder": "FA-2026-014",
          "hint": "Your reference for this agreement; unique in your organisation."
        },
        "titleEn": {
          "placeholder": "Catering supplies 2026"
        },
        "titleAr": {
          "placeholder": "توريدات التموين 2026"
        },
        "paymentTerms": {
          "placeholder": "30 days from invoice"
        },
        "sku": {
          "placeholder": "SKU-12345",
          "hint": "The supplier's own code for this item."
        },
        "itemNameEn": {
          "placeholder": "Arabica coffee beans, 1 kg"
        },
        "itemNameAr": {
          "placeholder": "حبوب قهوة عربية، 1 كغ"
        },
        "uom": {
          "placeholder": "kg",
          "hint": "The unit it is priced and ordered in."
        },
        "price": {
          "placeholder": "25.50",
          "hint": "Per unit of measure, before tax."
        },
        "moq": {
          "placeholder": "10",
          "hint": "The smallest quantity the supplier accepts in one order."
        },
        "reason": {
          "placeholder": "Annual price review"
        },
        "problems": {
          "referenceRequired": "Enter the agreement's reference.",
          "titleEnRequired": "Enter the name in English.",
          "titleArRequired": "Enter the name in Arabic.",
          "fromRequired": "Enter the first day it applies.",
          "toRequired": "Enter the last day it applies.",
          "toBeforeFrom": "The last day cannot be before the first.",
          "currencyRequired": "Choose the agreement's currency.",
          "nameEnRequired": "Enter the name in English.",
          "nameArRequired": "Enter the name in Arabic.",
          "uomRequired": "Enter the unit of measure.",
          "quantityFormat": "Enter a quantity above zero, in figures, like 10 or 2.5."
        }
      },
      "budget": {
        "summaryCreate": "The budget was not added",
        "summaryPeriod": "The period was not added",
        "summaryAllocate": "Nothing was moved",
        "scopeHint": "Leave empty to cover every purchasing unit.",
        "categoryHint": "Leave empty to cover every category.",
        "currencyHint": "Every amount in this budget is in this currency; nothing is converted.",
        "notes": {
          "placeholder": "Covers the October service menu"
        },
        "period": {
          "code": {
            "placeholder": "FY2027-Q1",
            "hint": "Short code, as it appears in reports."
          },
          "nameEn": {
            "placeholder": "First quarter 2027"
          },
          "nameAr": {
            "placeholder": "الربع الأول 2027"
          }
        },
        "reason": {
          "placeholder": "Moved to the new central kitchen"
        },
        "problems": {
          "periodRequired": "Choose the budget period.",
          "currencyRequired": "Choose the currency.",
          "codeRequired": "Enter the period's code.",
          "nameEnRequired": "Enter the name in English.",
          "nameArRequired": "Enter the name in Arabic.",
          "startsRequired": "Enter the first day.",
          "endsRequired": "Enter the last day.",
          "reasonRequired": "Say why the allocation is reduced."
        }
      },
      "portalUser": {
        "summary": "The portal account was not created",
        "name": {
          "placeholder": "Omar Example"
        },
        "email": {
          "placeholder": "orders@supplier.example",
          "hint": "Their sign-in address for the supplier portal."
        },
        "phone": {
          "placeholder": "+966 5X XXX XXXX"
        },
        "reason": {
          "placeholder": "Left the supplier's company"
        },
        "problems": {
          "nameRequired": "Enter their name.",
          "emailRequired": "Enter their email address.",
          "emailFormat": "Enter an email address like orders@supplier.example."
        }
      },
      "invoice": {
        "saved": "Supplier invoice recorded.",
        "number": {
          "placeholder": "INV-2026-00124"
        },
        "subtotal": {
          "placeholder": "1000.00"
        },
        "tax": {
          "placeholder": "150.00"
        }
      },
      "tax": {
        "rateHint": "A percentage from 0 to 100. Exempt and zero-rated codes use 0%."
      },
      "date": {
        "today": "Today",
        "clear": "Clear",
        "todayFor": "Use today for {{label}}",
        "clearFor": "Clear {{label}}",
        "prompt": "Select a date"
      },
      "optional": "(optional)",
      "fixFields_one": "Please fix 1 field before saving.",
      "fixFields_other": "Please fix {{count}} fields before saving.",
      "fixFields_zero": "Please fix {{count}} fields before saving.",
      "fixFields_two": "Please fix {{count}} fields before saving.",
      "fixFields_few": "Please fix {{count}} fields before saving.",
      "fixFields_many": "Please fix {{count}} fields before saving.",
      "codeHint": "Letters, digits, - and _ only; unique in your organisation.",
      "businessReason": {
        "placeholder": "Describe the business reason for this decision"
      },
      "warehouse": {
        "code": {
          "placeholder": "WH-RUH-01"
        },
        "nameEn": {
          "placeholder": "Riyadh Central Warehouse"
        },
        "nameAr": {
          "placeholder": "مستودع الرياض المركزي"
        },
        "phone": {
          "placeholder": "+966 11 XXX XXXX"
        },
        "email": {
          "placeholder": "warehouse@organisation.example"
        }
      },
      "category": {
        "code": {
          "placeholder": "CAT-PACKAGING"
        },
        "nameEn": {
          "placeholder": "Packaging and disposables"
        },
        "nameAr": {
          "placeholder": "التغليف والمستهلكات"
        }
      },
      "taxCode": {
        "code": {
          "placeholder": "VAT-STD-15"
        },
        "nameEn": {
          "placeholder": "Standard VAT 15%"
        },
        "nameAr": {
          "placeholder": "ضريبة القيمة المضافة القياسية 15%"
        }
      },
      "purchasingUnit": {
        "code": {
          "placeholder": "PU-RUH-PARK"
        },
        "nameEn": {
          "placeholder": "Riyadh Park outlet"
        },
        "nameAr": {
          "placeholder": "منفذ الرياض بارك"
        },
        "deactivateReason": {
          "placeholder": "Outlet closed at the end of its lease"
        }
      },
      "receipt": {
        "deliveryNote": {
          "placeholder": "DN-2026-0042"
        },
        "notes": {
          "placeholder": "Received at the rear loading bay at 09:30"
        },
        "problem": {
          "short": "Only 8 of 10 cartons delivered",
          "over": "12 cartons delivered against 10 ordered",
          "damaged": "2 cartons crushed in transit",
          "incorrect": "500 ml bottles delivered instead of 1 L",
          "rejected": "Use-by date already passed"
        },
        "overdue": {
          "placeholder": "Arrived two days after the promised date"
        },
        "closeShort": {
          "placeholder": "The supplier no longer supplies this item",
          "hint": "At least 3 characters."
        }
      },
      "quote": {
        "unitPrice": {
          "placeholder": "25.50"
        },
        "taxRate": {
          "placeholder": "15"
        }
      },
      "decision": {
        "partialReason": {
          "placeholder": "Reduced to match this month's expected usage"
        },
        "returnInstruction": {
          "placeholder": "Attach the supplier's quotation and confirm the quantity"
        }
      },
      "approvalRule": {
        "code": {
          "placeholder": "RULE-HIGH-VALUE"
        },
        "nameEn": {
          "placeholder": "High-value purchases"
        },
        "nameAr": {
          "placeholder": "المشتريات عالية القيمة"
        },
        "amount": {
          "placeholder": "50000",
          "from": "10000",
          "to": "50000"
        },
        "slaHours": {
          "placeholder": "24"
        }
      },
      "delegation": {
        "endsHint": "Must be after the start.",
        "maxAmount": {
          "placeholder": "50000.00",
          "hint": "Optional. Above zero; leave it empty for no ceiling."
        },
        "reason": {
          "placeholder": "Annual leave cover"
        }
      },
      "amendment": {
        "reason": {
          "placeholder": "Quantity reduced to match the revised menu",
          "hint": "Required, at least 3 characters. Recorded with the version and in the audit trail."
        },
        "notes": {
          "placeholder": "Deliver to the rear loading bay before 10:00"
        }
      },
      "catalogueItem": {
        "code": {
          "placeholder": "RET-ITEM-001"
        },
        "nameEn": {
          "placeholder": "Arabica coffee beans, 1 kg"
        },
        "nameAr": {
          "placeholder": "حبوب قهوة عربية، 1 كغ"
        },
        "uom": {
          "placeholder": "kg"
        },
        "descriptionEn": {
          "placeholder": "Medium roast, whole beans, sealed bag"
        },
        "descriptionAr": {
          "placeholder": "تحميص متوسط، حبوب كاملة، كيس محكم الإغلاق"
        }
      }
    }
  }
}
